var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"t-form",attrs:{"novalidate":""},on:{"submit":function($event){return _vm.$emit('submit', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }